/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2023-05-30 13:54:25
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2023-05-31 14:08:11
 * @FilePath: /jhy-frontend-pc/packages/share/utils/splitThousand.ts
 * @Description:
 *
 */

import { AnyRecord } from "dns";

function splitThousand(num: any) {
  num = Number(num);
  if (!num) {
    return 0;
  } else {
    let pre = "";
    if (Math.abs(num) < 1000) {
      return num;
    } else if (num < -1000) {
      num = Math.abs(num).toFixed(2);
      pre = "-";
    }
    var n0 = parseInt(String(num / 1000));

    let arr: any = [];
    if (/^-?\d+\.+\d*$/.test(num)) {
      //浮点数
      num = (num - 0).toFixed(2);
      arr = /\d{3}\.\d{2}/.exec(num);//本来是浮点的显示 .xx
    } else {
      arr = /\d{3}$/.exec(num);//不是浮点数的，不显示是.xx
      num = num - 0;
    }

    var n1 = "";
    if (arr && arr.length) {
      n1 = arr[0];
    }

    let str =
      pre +
      (n0 + "")
        .split("")
        .reverse()
        .join("")
        .replace(/(\d{3})(?=\d)/g, "$1,")
        .split("")
        .reverse()
        .join("") +
      "," +
      n1;

    return str;
  }
}
//金额
function money(value: any) {
  if (!value) {
    value = 0;
  }
  return "￥" + parseFloat(value).toFixed(2);
}

//格式化钱不带‘￥’,千位分隔
function currency(value: any) {
  if (!value) {
    if (value == undefined) {
      return "";
    }
    value = 0;
  }
  if (!parseFloat(value)) {
    return value;
  }
  if (/^-?\d+\.+\d*$/.test(value)) {
    //浮点数
    return splitThousand(parseFloat(value).toFixed(2));
  } else {
    return splitThousand(parseFloat(value));
  }
}
export { money, currency };
